<div class="knock-shell p-2 p-lg-3">
  <div class="head d-flex justify-content-between align-items-start gap-3">
    <div class="d-flex align-items-start gap-2">
      <span class="icon-box">
        <lucide-icon [img]="ClipboardCheckIcon" [size]="18"></lucide-icon>
      </span>
      <div>
        <div class="title">Payment Knock-Off</div>
        <div class="sub">Invoice and received payment reconciliation</div>
      </div>
    </div>

    <div class="client-wrap">
      <label class="lbl">Client Name</label>
      <select class="form-select form-select-sm" [value]="selectedClient()" (change)="onClientChange(($any($event.target).value || '').toString())">
        @for (item of clients(); track item) {
          <option [value]="item">{{ item }}</option>
        }
      </select>
    </div>
  </div>

  <div class="stats-grid mt-3">
    <div class="stat-card">
      <div class="k">Pending Invoice</div>
      <div class="v">{{ pendingInvoiceCount() }}</div>
    </div>
    <div class="stat-card">
      <div class="k">Total Invoice Amount (Rs.)</div>
      <div class="v">{{ inr(totalInvoiceAmount()) }}</div>
    </div>
    <div class="stat-card">
      <div class="k">Total Unpaid Amount (Rs.)</div>
      <div class="v">{{ inr(totalUnpaidAmount()) }}</div>
    </div>
    <div class="stat-card">
      <div class="k">Total Received Amount (Rs.)</div>
      <div class="v">{{ inr(totalReceivedAmount()) }}</div>
    </div>
    <div class="stat-card">
      <div class="k">Total Unsettled Amount (Rs.)</div>
      <div class="v">{{ inr(totalUnsettledAmount()) }}</div>
    </div>
  </div>

  <div class="panel mt-3">
    <div class="row g-3">
      <div class="col-lg-6">
        <div class="inner">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="h6 m-0 fw-bold">Outstanding Invoices</div>
            <span class="badge text-bg-primary-subtle">{{ filteredOutstanding().length }} Records</span>
          </div>
          <div class="row g-2">
            <div class="col-6">
              <label class="lbl">From Date</label>
              <input class="form-control form-control-sm" type="date" [value]="fromDate()" (input)="fromDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="col-6">
              <label class="lbl">To Date</label>
              <input class="form-control form-control-sm" type="date" [value]="toDate()" (input)="toDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="col-12">
              <label class="lbl">Search</label>
              <input class="form-control form-control-sm" [value]="invoiceSearch()" (input)="invoiceSearch.set(($any($event.target).value || '').toString())" placeholder="Search Invoice / Client" />
            </div>
          </div>
          <div class="table-responsive mt-2">
            <table class="table table-sm mb-0 grid">
              <thead>
                <tr>
                  <th></th>
                  <th>Invoice No.</th>
                  <th>Invoice Date</th>
                  <th>Issued To</th>
                  <th>Invoice Amount (Rs.)</th>
                  <th>Paid Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                @if (filteredOutstanding().length === 0) {
                  <tr><td colspan="6" class="text-center text-muted py-3">No data found</td></tr>
                }
                @for (row of filteredOutstanding(); track row.id) {
                  <tr>
                    <td><input type="checkbox" class="form-check-input" /></td>
                    <td>{{ row.invoiceNo }}</td>
                    <td>{{ row.invoiceDate }}</td>
                    <td>{{ row.issuedTo }}</td>
                    <td>{{ inr(row.invoiceAmount) }}</td>
                    <td class="text-primary fw-semibold">{{ inr(row.paidAmount) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="col-lg-6">
        <div class="inner">
          <div class="d-flex justify-content-between align-items-center mb-2">
            <div class="h6 m-0 fw-bold">Received Amount</div>
            <button type="button" class="btn btn-outline-primary btn-sm px-3" (click)="openPaymentModal()">
              <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
            </button>
          </div>
          <div class="row g-2">
            <div class="col-6">
              <label class="lbl">From Date</label>
              <input class="form-control form-control-sm" type="date" [value]="receivedFromDate()" (input)="receivedFromDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="col-6">
              <label class="lbl">To Date</label>
              <input class="form-control form-control-sm" type="date" [value]="receivedToDate()" (input)="receivedToDate.set(($any($event.target).value || '').toString())" />
            </div>
            <div class="col-12">
              <label class="lbl">Search</label>
              <input class="form-control form-control-sm" [value]="payerSearch()" (input)="payerSearch.set(($any($event.target).value || '').toString())" placeholder="Search Payer" />
            </div>
          </div>
          <div class="table-responsive mt-2">
            <table class="table table-sm mb-0 grid">
              <thead>
                <tr>
                  <th></th>
                  <th>Payment Ref. No.</th>
                  <th>Payment Date</th>
                  <th>Received From</th>
                  <th>Received Amount (Rs.)</th>
                  <th>Settled Amount (Rs.)</th>
                </tr>
              </thead>
              <tbody>
                @if (filteredReceived().length === 0) {
                  <tr><td colspan="6" class="text-center text-muted py-3">No data found</td></tr>
                }
                @for (row of filteredReceived(); track row.id) {
                  <tr>
                    <td><input type="checkbox" class="form-check-input" /></td>
                    <td>{{ row.paymentRefNo }}</td>
                    <td>{{ row.paymentDate }}</td>
                    <td>{{ row.receivedFrom }}</td>
                    <td>{{ inr(row.receivedAmount) }}</td>
                    <td>{{ inr(row.settledAmount) }}</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="panel mt-3">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <div class="h6 m-0 fw-bold">Reconciliation</div>
      <span class="pill">Amount Left : {{ inr(amountLeft()) }}</span>
    </div>
    <div class="table-responsive">
      <table class="table table-sm mb-0 grid">
        <thead>
          <tr>
            <th>Received Amount (Rs.)</th>
            <th>Unsettled Amount (Rs.)</th>
            <th>Adjusting Amount (Rs.)</th>
            <th>TDS Deduction (Rs.)</th>
            <th>GST On TDS</th>
            <th>Other Deduction (Rs.)</th>
            <th>Remarks</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{{ inr(totalReceivedAmount()) }}</td>
            <td>{{ inr(totalUnsettledAmount()) }}</td>
            <td><input class="form-control form-control-sm" value="200000" /></td>
            <td><input class="form-control form-control-sm" value="0" /></td>
            <td><input class="form-control form-control-sm" value="0" /></td>
            <td><input class="form-control form-control-sm" value="0" /></td>
            <td><input class="form-control form-control-sm" value="Opening adjustment" /></td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showPaymentModal()) {
  <div class="modal fade show d-block" tabindex="-1" role="dialog" aria-modal="true">
    <div class="modal-dialog modal-xl modal-dialog-centered" role="document">
      <div class="modal-content payment-modal">
        <div class="modal-header payment-modal-head">
          <h5 class="modal-title">Payment</h5>
          <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="closePaymentModal()"></button>
        </div>
        <div class="modal-body payment-modal-body">
          <div class="client-label"><strong>Client Name:</strong> {{ paymentForm().clientName || selectedClient() || '-' }}</div>
          <div class="row g-2 mt-1">
            <div class="col-md-4">
              <label class="lbl">Amount (Rs.)</label>
              <input class="form-control" type="number" min="0" step="0.01" placeholder="Enter amount" [value]="paymentForm().amount" (input)="updatePaymentField('amount', ($any($event.target).value || '').toString())" />
            </div>
            <div class="col-md-4">
              <label class="lbl">Transaction Date</label>
              <input class="form-control" type="date" [value]="paymentForm().transactionDate" (input)="updatePaymentField('transactionDate', ($any($event.target).value || '').toString())" />
            </div>
            <div class="col-md-4">
              <label class="lbl">Payment Mode</label>
              <select class="form-select" [value]="paymentForm().paymentMode" (change)="updatePaymentField('paymentMode', ($any($event.target).value || '').toString())">
                <option value="">Select Payment Mode</option>
                @for (mode of paymentModes; track mode) {
                  <option [value]="mode">{{ mode }}</option>
                }
              </select>
            </div>
            <div class="col-md-4">
              <label class="lbl">Reference Number</label>
              <input class="form-control" type="text" placeholder="Enter reference number" [value]="paymentForm().referenceNumber" (input)="updatePaymentField('referenceNumber', ($any($event.target).value || '').toString())" />
            </div>
            <div class="col-md-8">
              <label class="lbl">From Bank</label>
              <select class="form-select" [value]="paymentForm().fromBank" (change)="updatePaymentField('fromBank', ($any($event.target).value || '').toString())">
                <option value="">Select Bank</option>
                @for (bank of banks; track bank) {
                  <option [value]="bank">{{ bank }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="lbl">From IFSC Code</label>
              <input class="form-control" type="text" placeholder="IFSC Code" [value]="paymentForm().fromIfsc" (input)="updatePaymentField('fromIfsc', ($any($event.target).value || '').toString())" />
            </div>
            <div class="col-md-6">
              <label class="lbl">To Bank</label>
              <select class="form-select" [value]="paymentForm().toBank" (change)="updatePaymentField('toBank', ($any($event.target).value || '').toString())">
                <option value="">Select Bank</option>
                @for (bank of banks; track bank) {
                  <option [value]="bank">{{ bank }}</option>
                }
              </select>
            </div>
            <div class="col-md-6">
              <label class="lbl">To IFSC Code</label>
              <input class="form-control" type="text" placeholder="IFSC Code" [value]="paymentForm().toIfsc" (input)="updatePaymentField('toIfsc', ($any($event.target).value || '').toString())" />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-dark px-4" (click)="closePaymentModal()">CLOSE</button>
          <button type="button" class="btn btn-success px-4" (click)="savePayment()">SAVE</button>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade show" (click)="closePaymentModal()"></div>
}
